import {AxiosError} from 'axios';
import {POST_PHOTO_UPLOAD_VALIDATE_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface uuidRequest {
  uuid: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostPhotoUploadValidate = ({onSuccess, onError}: Input = {}) => {
  const postPhotoUploadValidate = async (reqBody: uuidRequest) => {
    const res = await axiosClient.post(POST_PHOTO_UPLOAD_VALIDATE_URL, reqBody);
    return res.data;
  };

  return useCustomMutation(postPhotoUploadValidate, {
    onSuccess,
    onError,
  });
};
